export default {
      id: "closed-usage",
      viewBox: "0 0 22 22",
      url: "assets/" + "sprite.svg#closed",
      toString: function () {
        return this.url;
      }
    }